<script setup>
import {onMounted, ref} from "vue";
import { useNotificationStore } from '@/stores/NotificationStore.js'
const notificationStore = useNotificationStore()

const props = defineProps({
    frontPageType: {
        type: String,
        required: true
    },
    label: {
        type: String,
        required: false,
        default: ''
    }
})

const frontPageId = ref(null)
const pages = ref([])

const storeFrontPage = async (selectedId) => {
    if (selectedId === null || selectedId === '') {
        return false
    }

    let res
    try {
        res = await axios.post(route('settings.frontpage.update', {type: props.frontPageType}), {
            front_page_type: props.frontPageType,
            front_page_id: selectedId,
        })
    } catch (e) {
        notifyError()
        return
    }

    if(res.data.success !== true) {
        notifyError()
    } else {
        notificationStore.addNotification({
            type: 'success',
            title: _mft('setting:navigation.frontPage.saved.title'),
            message: _mft('setting:navigation.frontPage.saved.message', {title: res.data.front_page_title}),
            dismissAfter: 5000,
        })
    }
}

const notifyError = () => {
    notificationStore.addNotification({
        type: 'error',
        title: _mft('setting:navigation.frontPage.error.title'),
        message: _mft('setting:navigation.frontPage.error.message'),
        dismissAfter: 5000,
    })
}

const loadFrontpageSettings = async () => {
    const res = await axios.get(route('settings.frontpage.show', {type: props.frontPageType}))
    pages.value = res.data.pages
    frontPageId.value = res.data.front_page_id
}

onMounted(() => {
    loadFrontpageSettings()
})

</script>

<template>
    <div>
        <div class="flex justify-between items-center space-x-4">
            <div class="flex items-center justify-between space-x-4">
                <input-select
                    v-model:content="frontPageId"
                    @update:content="storeFrontPage"
                    :options="pages"
                    labelSpecification="title"
                    valueSpecification="id"
                    class="!mb-0"
                    :label="props.label"
                />
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
